$(document).ready(function () {

    $("#js-form-news").submit(function (event) {
        event.preventDefault();

        var data = {
            "nome": $(this).find("#nome").val(),
            "email": $(this).find("#email").val(),
        };

        var action = newsLetter.addEmail(data);
    });

    var newsLetter        = new NewsLetter();
    var newsLetterBox     = $(".newsletter__box");
    var newsLetterMessage = $(".newsletter__message");

    $(newsLetter).bind("onSuccessAddEmailNewsLetter", function (event, data) {
        event.preventDefault();
        newsLetterBox.addClass("is-active");
        newsLetterMessage.html("Email enviado com sucesso!").addClass("success");
        // $('#email').val('').attr('placeholder', 'Email enviado com sucesso').addClass('is-success');
        setTimeout(function () {
            newsLetterBox.removeClass("is-active");
            newsLetterMessage.removeClass("success");
            // $('#email').attr('placeholder', 'Email').removeClass('is-success')
        }, 1200);
    }).bind("onFailAddEmailNewsLetter500", function (event, data, jqXHR, textStatus, errorThrown) {
        newsLetterBox.addClass("is-active");
        newsLetterMessage.html("O email já está cadastrado!").addClass("error");
        // $('#email').val('').attr('placeholder', 'O email já está cadastrado!').addClass('error');
        setTimeout(function () {
            newsLetterBox.removeClass("is-active");
            newsLetterMessage.removeClass("error");
            // $('#email').attr('placeholder', 'Email').removeClass('is-error');
        }, 1200);
        newsLetterBox.addClass("is-active");
        newsLetterMessage.html(data.email[0]).addClass("error");
    }).bind("onFailAddEmailNewsLetter", function (event, data, jqXHR, textStatus, errorThrown) {
        event.preventDefault();
        console.log("Error: ", data);
        newsLetterBox.addClass("is-active");
        newsLetterMessage.html(data.email[0]).addClass("error");
        // $('#email').val('').attr('placeholder', data.email[0]).addClass('is-error');
        setTimeout(function () {
            newsLetterBox.removeClass("is-active");
            newsLetterMessage.removeClass("error");
            // $('#email').attr('placeholder', 'Email').removeClass('is-error');
        }, 1200);
    }).bind("onAlwaysAddEmailNewsLetter", function (event, data_or_jqXHR, textStatus, jqXHR_or_errorThrown) {

    });
});